if (!customElements.get('image-with-hotspots')) {
  customElements.define('image-with-hotspots', class ImageWithHotspots extends ProductCard {
    constructor() {
      super();

      this.sectionId = this.id;
      this.useSameImage = this.getAttribute('use-same-image') === 'true';
      this.swatches = this.querySelectorAll('.swatch');
      this.images = this.querySelectorAll('.hotspot-container');
      this.addToCartbutton = this.querySelector('button[type="submit"]');
      this.priceElement = this.querySelector('.price');
      this.handle = this.getAttribute('handle');
      this.json = JSON.parse(this.querySelector('[type="application/json"]').textContent);
    }

    async onSwatchClick(event) {
      event.preventDefault();

      const swatch = event.currentTarget;
      const index = swatch.getAttribute('data-index');
      const variantName = swatch.getAttribute('data-variant-name');
      const variantId = swatch.getAttribute('data-variant-id');
      this.currentVariant = this.json.find(variant => variant.id === parseInt(variantId));

      this.updateActiveSwatch(index);
      this.updateImage(variantName);

      try {
        const productInfo = await this.fetchProductInfo(variantId);
        this.updatePrice(productInfo);
      } catch (error) {
        console.error("Error fetching product info:", error);
      }

      if (this.addToCartbutton) {
        if (!this.currentVariant) {
          this.toggleAddButton(true);
          super.setUnavailable();
        } else {
          this.toggleAddButton(!this.currentVariant.available);
          this.updateVariantInput();
        }
      }
    }

    updateVariantInput() {
      const productForms = this.querySelectorAll('product-form');
      productForms.forEach((productForm) => {
        const input = productForm.querySelector('input[name="items[0]id"]');
        input.value = this.currentVariant.id;
      });
    }

    updateActiveSwatch(index) {
      this.swatches.forEach(swatch => {
        swatch.classList.toggle('active', swatch.getAttribute('data-index') === index.toString());
      });
    }

    updateImage(variantName) {
      if (this.useSameImage) return;

      this.images.forEach(image => {
        image.classList.toggle('active', image.getAttribute('data-variant-name') === variantName);
      });
    }

    toggleAddButton(disable = true) {
      const addButtonText = this.addToCartbutton.querySelector('span');

      if (disable) {
        this.addToCartbutton.setAttribute('disabled', 'disabled');
        addButtonText.textContent = window.variantStrings.soldOut;
      } else {
        this.addToCartbutton.removeAttribute('disabled');
        addButtonText.textContent = this.addToCartbutton.getAttribute('data-button-label');
      }
    }
  });
}